<template>
  <span>
    <slot :openModal="openModal"></slot>
    <b-modal v-model="showModal" title="Edit Profile Info" hide-footer size="lg">
      <onboarding-interests @cancel="showModal = false" @saved="handleProfileChanged"/>
    </b-modal>
  </span>
</template>
<script>
import OnboardingProfileEdit from "./OnboardingProfileEdit.vue";
import OnboardingInterests from "./OnboardingInterests.vue";

export default {
  components: {OnboardingInterests, OnboardingProfileEdit},
  mixins: [],
  props: {},
  data() {
    return {
      showModal: false
    }
  },
  mounted() {},
  methods: {
    openModal() {
      this.showModal = true
    },
    handleProfileChanged() {
      this.showModal = false
      window.location.reload()
    }
  },
  computed: {}
}
</script>